// Static product showcase data for Rocket Card Shop.
// SEALED inventory is sourced from the Collectr CSV export.
// Update by replacing the SEALED_ITEMS array below.

export const SHOP_INFO = {
  name: "Rocket Card Shop",
  city: "Springtown, TX",
  tagline: "Springtown's Premier Pokémon Vault",
  appointmentNote:
    "By appointment only — every visit is private, focused, and built around what you came to do.",
  phone: "817-944-6170",
  email: "martinezss2002@gmail.com",
  address: "219 Cactus Ridge Ct, Springtown, TX 76082",
  hours: [
    { day: "Mon — Fri", time: "By Appointment" },
    { day: "Saturday",  time: "10:00 AM — 6:00 PM (by appointment)" },
    { day: "Sunday",    time: "Closed" },
  ],
  socials: [
    { label: "Instagram", href: "https://www.instagram.com/rocketcardshop2?fbclid=IwY2xjawSf85RleHRuA2FlbQIxMABzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEeOYDnfoYivKKX5pODC0dwnJzusxpfVVZgjaeqdsTs1-rHBVy1W8P831rks9Q_aem_GtzCKxY852bKWXgMlmxHKw", handle: "@rocketcardshop2" },
    { label: "Facebook",  href: "https://www.facebook.com/profile.php?id=61581193862176", handle: "Rocket Card Shop" },
  ],
};

// ------------------------------------------------------------------
// SEALED ITEMS — imported from Collectr export
// ------------------------------------------------------------------
export const SEALED_ITEMS = [
  // Pokémon
  { brand: "Pokémon", set: "Astral Radiance", name: "Astral Radiance 3 Pack Blister [Sylveon]", qty: 1, price: 34.83 },
  { brand: "Pokémon", set: "Astral Radiance", name: "Astral Radiance Single Pack Blister [Oricorio]", qty: 4, price: 11.67 },
  { brand: "Pokémon", set: "Battle Styles", name: "Battle Styles Elite Trainer Box [Rapid Strike Urshifu] (Blue)", qty: 1, price: 113.39 },
  { brand: "Pokémon", set: "Battle Styles", name: "Battle Styles Elite Trainer Box [Single Strike Urshifu] (Red)", qty: 1, price: 112.17 },
  { brand: "Pokémon", set: "Black Bolt", name: "Black Bolt Elite Trainer Box", qty: 3, price: 144.81 },
  { brand: "Pokémon", set: "Black Bolt", name: "Unova Poster Collection", qty: 2, price: 43.87 },
  { brand: "Pokémon", set: "Black Bolt", name: "Unova Victini Illustration Collection", qty: 1, price: 68.61 },
  { brand: "Pokémon", set: "Chaos Rising", name: "Chaos Rising Elite Trainer Box", qty: 1, price: 78.31 },
  { brand: "Pokémon", set: "Darkness Ablaze", name: "Eternatus VMAX Premium Collection", qty: 1, price: 163.70 },
  { brand: "Pokémon", set: "Destined Rivals", name: "Destined Rivals 3 Pack Blister [Zebstrika]", qty: 2, price: 41.01 },
  { brand: "Pokémon", set: "Destined Rivals", name: "Destined Rivals Booster Box", qty: 1, price: 597.67 },
  { brand: "Pokémon", set: "Destined Rivals", name: "Destined Rivals Elite Trainer Box", qty: 2, price: 208.32 },
  { brand: "Pokémon", set: "Destined Rivals", name: "Destined Rivals Sleeved Booster Pack", qty: 36, price: 12.25 },
  { brand: "Pokémon", set: "Journey Together", name: "Journey Together 3 Pack Blister [Scrafty]", qty: 5, price: 23.86 },
  { brand: "Pokémon", set: "Journey Together", name: "Journey Together 3 Pack Blister [Yanmega]", qty: 6, price: 23.67 },
  { brand: "Pokémon", set: "Journey Together", name: "Journey Together Sleeved Booster Pack", qty: 15, price: 8.41 },
  { brand: "Pokémon", set: "Mega Evolution", name: "Mega Evolution 3 Pack Blister [Psyduck]", qty: 2, price: 40.02 },
  { brand: "Pokémon", set: "Mega Evolution", name: "Mega Evolution Elite Trainer Box [Mega Gardevoir]", qty: 1, price: 107.97 },
  { brand: "Pokémon", set: "Mega Evolution", name: "Mega Evolution Elite Trainer Box [Mega Lucario]", qty: 1, price: 117.82 },
  { brand: "Pokémon", set: "Miscellaneous", name: "2-Pack Blister Pack [Oddish, Gloom, & Vileplume]", qty: 13, price: 17.34 },
  { brand: "Pokémon", set: "Miscellaneous", name: "2 Pack Blister [Snorlax, Morpeko & Applin Cards]", qty: 1, price: 28.14 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Azure Legends Tin [Dialga ex] (International Version)", qty: 1, price: 40.74 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Azure Legends Tin [Kyogre ex] (International Version)", qty: 1, price: 36.66 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Azure Legends Tin [Xerneas ex] (International Version)", qty: 2, price: 35.68 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Cynthia's Garchomp ex Premium Collection", qty: 1, price: 64.30 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Enhanced 2-Pack Blister Pack [Articuno, Zapdos, & Moltres]", qty: 28, price: 28.93 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Houndstone ex Box", qty: 3, price: 38.82 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Iono's Bellibolt ex Premium Collection", qty: 5, price: 54.13 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Jirachi GX Collection", qty: 1, price: 353.80 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Mega Kangaskhan ex Box", qty: 1, price: 37.41 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Mega Latias ex Box", qty: 2, price: 39.01 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Palafin ex Box", qty: 3, price: 35.46 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Pokémon Day 2026 Collection", qty: 5, price: 39.68 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Pokémon Stacking Tin: Ogerpon", qty: 2, price: 26.00 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Pokémon Stacking Tin: Treasures of Ruin", qty: 1, price: 28.64 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Strong Bonds Tin [Blissey]", qty: 1, price: 42.20 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Team Rocket's Mewtwo ex Box", qty: 1, price: 52.18 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Team Rocket's Moltres ex Ultra-Premium Collection", qty: 1, price: 328.60 },
  { brand: "Pokémon", set: "Miscellaneous", name: "Venusaur ex & Blastoise ex Premium Collection", qty: 2, price: 87.95 },
  { brand: "Pokémon", set: "Phantasmal Flames", name: "2-Pack Blister Pack [Raikou] (3-tab)", qty: 12, price: 17.34 },
  { brand: "Pokémon", set: "Phantasmal Flames", name: "Phantasmal Flames Elite Trainer Box", qty: 2, price: 148.30 },
  { brand: "Pokémon", set: "Phantasmal Flames", name: "Phantasmal Flames Single Pack Blister [Cottonee]", qty: 21, price: 11.69 },
  { brand: "Pokémon", set: "Phantasmal Flames", name: "Phantasmal Flames Sleeved Booster Pack", qty: 6, price: 12.51 },
  { brand: "Pokémon", set: "Prismatic Evolutions", name: "Prismatic Evolutions Booster Bundle + Surprise Box Bundle (Sam's Club)", qty: 1, price: 154.48 },
  { brand: "Pokémon", set: "Prismatic Evolutions", name: "Prismatic Evolutions Booster Pack", qty: 15, price: 17.77 },
  { brand: "Pokémon", set: "Prismatic Evolutions", name: "Prismatic Evolutions Elite Trainer Box", qty: 4, price: 158.11 },
  { brand: "Pokémon", set: "Prismatic Evolutions", name: "Prismatic Evolutions Surprise Box", qty: 11, price: 70.83 },
  { brand: "Pokémon", set: "Shrouded Fable", name: "Kingambit Illustration Collection", qty: 5, price: 43.64 },
  { brand: "Pokémon", set: "Silver Tempest", name: "Silver Tempest Single Pack Blister [Basculin]", qty: 4, price: 12.26 },
  { brand: "Pokémon", set: "Silver Tempest", name: "Silver Tempest Single Pack Blister [Cranidos]", qty: 3, price: 12.95 },
  { brand: "Pokémon", set: "Super Electric Breaker", name: "Super Electric Breaker Booster Box (JP)", qty: 1, price: 100.75 },
  { brand: "Pokémon", set: "Surging Sparks", name: "Surging Sparks Booster Box", qty: 2, price: 287.28 },
  { brand: "Pokémon", set: "Surging Sparks", name: "Surging Sparks Booster Bundle", qty: 3, price: 62.14 },
  { brand: "Pokémon", set: "Temporal Forces", name: "Temporal Forces 3 Pack Blister [Cyclizar]", qty: 4, price: 27.10 },
  { brand: "Pokémon", set: "Temporal Forces", name: "Temporal Forces Single Pack Blister [Bellibolt]", qty: 9, price: 10.03 },
  { brand: "Pokémon", set: "White Flare", name: "White Flare Elite Trainer Box", qty: 3, price: 125.05 },
  // One Piece
  { brand: "One Piece", set: "Adventure on Kami's Island", name: "Adventure on Kami's Island — Sleeved Booster Pack", qty: 15, price: 12.07 },
  { brand: "One Piece", set: "Adventure on Kami's Island", name: "Double Pack Set Vol. 10", qty: 1, price: 29.17 },
  { brand: "One Piece", set: "A Fist of Divine Speed", name: "Double Pack Set Volume 7", qty: 1, price: 76.16 },
  { brand: "One Piece", set: "The Time of Battle", name: "The Time of Battle Sleeved Booster Pack", qty: 13, price: 10.60 },
  { brand: "One Piece", set: "Ultra Deck: The Three Brothers", name: "Ultra Deck: The Three Brothers", qty: 2, price: 81.49 },
  // Dragon Ball Super
  { brand: "Dragon Ball Super", set: "Theme Selection: History of Son Goku", name: "Theme Selection — History of Son Goku", qty: 1, price: 42.80 },
];

// ------------------------------------------------------------------
// CATEGORIES
// ------------------------------------------------------------------
export const CATEGORIES = [
  {
    id: "sealed",
    title: "Sealed",
    tag: "01",
    mode: "inventory",
    blurb:
      "Booster boxes, ETBs, collection boxes, blisters, tins, and sleeved packs — factory sealed and ready for your shelf or rip session.",
    image:
      "https://customer-assets.emergentagent.com/job_rocket-card-shop/artifacts/7ccrbwme_unnamed.jpg",
  },
  {
    id: "slabs",
    title: "Slabs",
    tag: "02",
    mode: "in-shop",
    blurb:
      "PSA, BGS, and CGC graded showpieces — vintage holos, modern chase cards, and one-of-one moments worth protecting.",
    image:
      "https://customer-assets.emergentagent.com/job_rocket-card-shop/artifacts/ek8z7oj9_IMG_0329.jpeg",
    inShopNote:
      "Our graded lineup rotates constantly — vintage holos, modern alt-art chase cards, and rare grades. Book a visit to browse the case in person.",
  },
  {
    id: "singles",
    title: "Singles",
    tag: "03",
    mode: "in-shop",
    blurb:
      "Raw singles across every era — playables, binder fillers, vintage holos, and modern alt arts. Bring your wantlist.",
    image:
      "https://images.unsplash.com/photo-1696382447518-589582d4c8c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxwb2tlbW9uJTIwY2FyZHMlMjBmbGF0JTIwbGF5fGVufDB8fHx8MTc4MTM5Mzc4MHww&ixlib=rb-4.1.0&q=85",
    inShopNote:
      "Thousands of raw singles in the binders — every era, every era's chase cards, and a deep playable stock. Bring your wantlist when you visit.",
  },
];

export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_rocket-card-shop/artifacts/7ccrbwme_unnamed.jpg";
